import { create } from "zustand";

interface BaselineState {
  baselineId: string | null;
  setBaselineId: (id: string | null) => void;
}

export const useBaselineStore = create<BaselineState>((set) => ({
  baselineId: null,
  setBaselineId: (id) => set({ baselineId: id }),
}));

/** Convenience hook — returns the selected baseline_id or null for "all time". */
export function useActiveBaseline(): string | null {
  return useBaselineStore((s) => s.baselineId);
}
